import ToastExample from "./examples/Toast.Example";

export default [
    {
        title: "Basic toast",
        component: ToastExample,
        code: require("!raw-loader!./examples/Toast.Example.tsx")
    }
];
